import { useEffect, useState } from 'react';
import { getImageUrl, getStudentPhotoUrl, getCompanyLogoUrl } from '../utils/imageUtils';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import moment from 'moment';
import TaskSkeleton from './TaskSkeleton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faPaperPlane, faEnvelope, faEdit, faCheck, faBan, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

export default function Company_view() {
    const { http, user } = AuthUser();
    const [tasks, setTasks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [selectedDepartmentId, setselectedDepartmentId] = useState("");
    const [selectedStatus, setsselectedStatus] = useState("Pending");
    const [editUser, setEditUser] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(null);
    const [showReportModal, setShowReportModal] = useState(false);
    const [reportEmail, setReportEmail] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null);

    useEffect(() => {
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
    }, [selectedStatus]);

    const fetchTaskDetails = (selstatus = '') => {
        setIsLoading(true);
        let endpoint;
        endpoint = `/company?status=${selstatus}`;
        http.get(endpoint).then((res) => {
            setIsLoading(false);
            if (Array.isArray(res.data.data)) {
                setTasks(res.data.data);
            } else {
                console.error("API response is not an array");
            }
        }).catch(error => {
            setIsLoading(false);
            console.error("Error fetching tasks:", error);
        });
    }

    const handleSave = async (id) => {
        if (!window.confirm("Deactivate this company? Users under this company will not be able to login.")) {
            return;
        }
        try {
            const response = await http.put(`/company/${id}/deactivate`);
            if (response.data.success) {
                toast.success(response.data.message || "Company deactivated!");
                setTasks((prevTasks) =>
                    prevTasks.map((task) =>
                        task.id === id ? { ...task, status: 0 } : task
                    )
                );
            } else {
                toast.error(response.data.message || "Failed to deactivate company");
            }
        } catch (error) {
            console.error("Error deactivating company:", error);
            toast.error(error.response?.data?.message || "Failed to deactivate company");
        }
    };

    const handleApproveSave = async (idCompany) => {
        if (!window.confirm("Activate / approve this company?")) {
            return;
        }
        try {
            const response = await http.put(`/company/${idCompany}/activate`);
            if (response.data.success) {
                toast.success(response.data.message || "Company activated!");
                setTasks((prevTasks) =>
                    prevTasks.map((task) =>
                        task.id === idCompany ? { ...task, status: 1 } : task
                    )
                );
            } else {
                // Fallback to legacy approve endpoint
                await http.get(`/approve_company_admin?company=${idCompany}`);
                toast.success("Approved successfully!");
                setTasks((prevTasks) =>
                    prevTasks.map((task) =>
                        task.id === idCompany ? { ...task, status: 1 } : task
                    )
                );
            }
        } catch (err) {
            console.error("Error on approval", err);
            toast.error(err.response?.data?.message || "Failed to activate company");
        }
    };

    const handleChangeModal = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const [formData, setFormData] = useState({
        company_address: user.company_address || '',
        company_name: user.company_name || '',
        contact_name: user.contact_name || '',
        contact_phone: user.contact_phone || '',
    });

    const handleToggleReceipt = async (companyId) => {
        try {
            const response = await http.put(`/company/${companyId}/toggle-receipt`);
            if (response.data.message) {
                toast.success(response.data.message);
                // Update the local state to reflect the change
                setTasks(prevTasks => 
                    prevTasks.map(task => 
                        task.id === companyId 
                            ? { ...task, is_receipt: response.data.is_receipt }
                            : task
                    )
                );
            }
        } catch (error) {
            console.error("Error toggling receipt status:", error);
            toast.error("Failed to update receipt status");
        }
    }

    const handleToggleExpenseModule = async (companyId) => {
        try {
            const response = await http.put(`/company/${companyId}/toggle-expense-module`);
            if (response.data.message) {
                toast.success(response.data.message);
                setTasks(prevTasks =>
                    prevTasks.map(task =>
                        task.id === companyId
                            ? { ...task, show_expense_module: response.data.show_expense_module }
                            : task
                    )
                );
            }
        } catch (error) {
            console.error("Error toggling expense module:", error);
            toast.error("Failed to update expense module status");
        }
    }

    const openEditModal = (user) => {
        setShowModal(true);
        setFormData({
            company_address: user.company_address || '',
            company_name: user.company_name || '',
            contact_name: user.contact_name || '',
            contact_phone: user.contact_phone || '',
        });
        setLogoFile(null);
        setLogoPreview(user.company_logo ? getImageUrl(user.company_logo) : null);
        setEditUser(user);
    };

    const saveEditedUser = async (e) => {
        e.preventDefault();
        try {
            if (!editUser) {
                console.error("No user data to edit.");
                return;
            }

            const fd = new FormData();
            fd.append('_method', 'PUT');
            fd.append('company_name', formData.company_name);
            fd.append('company_address', formData.company_address);
            fd.append('contact_name', formData.contact_name);
            fd.append('contact_phone', formData.contact_phone);
            if (logoFile) {
                fd.append('company_logo', logoFile);
            }

            const response = await http.post(`/company/${editUser.id}`, fd, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            if (Array.isArray(response.data.data)) {
                toast.success("Company updated successfully!");
                setShowModal(false);
                setLogoFile(null);
                fetchTaskDetails(selectedDepartmentId, selectedStatus);
            } else {
                console.log("API response is not an array");
            }
        } catch (error) {
            console.error("Error updating company", error);
            toast.error("An error occurred while updating the company.");
        }
    };

    const closeModal = () => {
        setShowModal(false);
        setLogoFile(null);
        setLogoPreview(null);
    }

    const handleLogoChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLogoFile(file);
            setLogoPreview(URL.createObjectURL(file));
        }
    };
    
    const openReportModal = (company) => {
        setSelectedCompany(company);
        // Pre-fill with admin email if available
        setReportEmail(company.admin?.email || '');
        setShowReportModal(true);
    };
    
    const closeReportModal = () => {
        setShowReportModal(false);
        setSelectedCompany(null);
    };
    
    const handleEmailChange = (e) => {
        setReportEmail(e.target.value);
    };
    
    const sendReport = async () => {
        if (!selectedCompany) return;
        
        try {
            setIsLoading(true);
            const response = await http.get(`/student_annual_fee_sub_mail?company_id=${selectedCompany.id}&email=${reportEmail}`);
            setIsLoading(false);
            
            if (response.data.message) {
                toast.success(response.data.message);
                closeReportModal();
            } else {
                toast.error("Failed to send report");
            }
        } catch (error) {
            setIsLoading(false);
            console.error("Error sending report:", error);
            toast.error("An error occurred while sending the report");
        }
    };
    console.log(tasks);
    return (
        <>
            <div className='row mb-2'>
                <div className='col-md-4'>
                    <h1>School List</h1> </div>
                <Link className="mb-3 add_link text-end p-4" to="/company_add">Add</Link>
            </div>
            <Toaster />

            {/* Report Modal */}
            {showReportModal && selectedCompany && (
                <div className="modal" tabIndex="-1" style={{ display: 'block' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header bg-info text-white">
                                <h5 className="modal-title">
                                    <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                    Send Report for {selectedCompany.company_name}
                                </h5>
                                <button type="button" className="btn-close" onClick={closeReportModal}></button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group mb-3">
                                    <label className="form-label">Email Address</label>
                                    <input 
                                        type="email" 
                                        className="form-control" 
                                        placeholder="Enter email address" 
                                        value={reportEmail}
                                        onChange={handleEmailChange}
                                        required
                                    />
                                    <small className="form-text text-muted">
                                        The report will be sent to this email with BCC to administrators.
                                    </small>
                                </div>
                                <div className="alert alert-info">
                                    <small>
                                        <FontAwesomeIcon icon={faEnvelope} className="me-2" />
                                        This will send a report containing fee data from the last year for company ID: {selectedCompany.id}
                                    </small>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeReportModal}>Cancel</button>
                                <button 
                                    type="button" 
                                    className="btn btn-primary" 
                                    onClick={sendReport}
                                    disabled={isLoading || !reportEmail}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                            Sending...
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon icon={faPaperPlane} className="me-2" />
                                            Send Report
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal && (
                <form onSubmit={saveEditedUser}>
                    <div className="modal" tabIndex="-1" style={{ display: 'block' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Edit Company Details</h5>
                                    <button type="button" className="btn-close" onClick={closeModal}></button>
                                </div>
                                <div className="modal-body">
                                    <div className='form-group  mt-3'>
                                        <label>Company Name</label>
                                        <input name="company_name" required className='form-control' type="text" value={formData.company_name}
                                            onChange={handleChangeModal} />
                                    </div>
                                    <div className='form-group  mt-3'>
                                        <label>Address</label>
                                        <input name="company_address" required className='form-control' type="text" value={formData.company_address}
                                            onChange={handleChangeModal} />
                                    </div>
                                    <div className='form-group  mt-3'>
                                        <label>Contacct Person</label>
                                        <input name="contact_name" required className='form-control' type="text" value={formData.contact_name}
                                            onChange={handleChangeModal} />
                                    </div>

                                    <div className='form-group  mt-3'>
                                        <label>Contact Phone</label>
                                        <input name="contact_phone" required className='form-control' type="text" value={formData.contact_phone}
                                            onChange={handleChangeModal} />
                                    </div>

                                    <div className='form-group mt-3'>
                                        <label>Company Logo</label>
                                        <div className="d-flex align-items-center gap-3 mt-1">
                                            {logoPreview && (
                                                <img
                                                    src={logoPreview}
                                                    alt="Logo Preview"
                                                    style={{ width: '60px', height: '60px', objectFit: 'contain', border: '1px solid #dee2e6', borderRadius: '6px', padding: '4px' }}
                                                />
                                            )}
                                            <input
                                                type="file"
                                                className="form-control"
                                                accept="image/*"
                                                onChange={handleLogoChange}
                                            />
                                        </div>
                                        <small className="text-muted">Leave empty to keep current logo</small>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeModal}>Close</button>
                                    <button type="submit" className="btn btn-primary" >Save changes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            <div className="table-responsive">
                {isLoading ? (
                    <TaskSkeleton />

                ) : (
                    <table className="table table-striped table-bordered align-middle">
                        <thead className="table-primary">
                            <tr className="text-center">
                                <th className='text-danger' width="100">Created On</th>
                                <th width="50">ID</th>
                                <th width="120">Company Code</th>
                                <th width="200">Company Name</th>
                                <th width="150">Contact Person</th>
                                <th width="120">Contact No</th>
                                <th width="200">Address</th>
                                <th width="70">Logo</th>
                                <th width="100">Status</th>
                                <th width="110">Expense</th>
                                <th width="200">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tasks.map(comp => (
                                <tr key={comp.id}>
                                    <td className="text-center">{moment(comp.created_at).format('DD MMM,YY')}</td>
                                    <td className="text-center">{comp.id}</td>
                                    <td className='font-weight-bold'>{comp.company_id}</td>
                                    <td>{comp.company_name}
                                        <br /><b>Email:</b> {comp.admin?.email}
                                        <br /><b>Pass:</b> {comp.admin?.pass}
                                    </td>
                                    <td>{comp.contact_name}</td>
                                    <td>{comp.contact_phone}</td>
                                    <td>{comp.company_address}</td>
                                    <td className="text-center">
                                        <img src={getImageUrl(comp.company_logo)} width="35" alt="Company Logo" height="35" />
                                    </td>
                                    <td className="text-center">
                                        {comp.status == 1 ? 
                                            <span className="badge bg-success">Active</span> : 
                                            <span className="badge bg-danger">Non-Active</span>}
                                    </td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className={`btn btn-sm ${comp.show_expense_module == 1 ? 'btn-success' : 'btn-secondary'}`}
                                            style={{ fontSize: '11px', padding: '2px 8px' }}
                                            onClick={() => handleToggleExpenseModule(comp.id)}
                                            title={comp.show_expense_module == 1 ? "Expense Module: ON" : "Expense Module: OFF"}
                                        >
                                            <FontAwesomeIcon icon={comp.show_expense_module == 1 ? faToggleOn : faToggleOff} className="me-1" />
                                            {comp.show_expense_module == 1 ? 'ON' : 'OFF'}
                                        </button>
                                    </td>
                                    <td>
                                        <div className="d-flex justify-content-center gap-1">
                                            <button 
                                                className='btn btn-sm btn-danger' 
                                                style={{fontSize: '11px', padding: '2px 5px'}} 
                                                onClick={() => handleSave(comp.id)}
                                                title="De-Activate"
                                                disabled={comp.status == 0}
                                            >
                                                <FontAwesomeIcon icon={faBan} />
                                            </button>
                                            
                                            <button 
                                                className='btn btn-sm btn-success' 
                                                style={{fontSize: '11px', padding: '2px 5px'}} 
                                                onClick={() => handleApproveSave(comp.id)}
                                                title="Activate / Approve"
                                                disabled={comp.status == 1}
                                            >
                                                <FontAwesomeIcon icon={faCheck} />
                                            </button>
                                            
                                            {user.status === 1 && 
                                                <button 
                                                    className='btn btn-sm btn-primary' 
                                                    style={{fontSize: '11px', padding: '2px 5px'}} 
                                                    onClick={() => openEditModal(comp)}
                                                    title="Edit"
                                                >
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>
                                            }
                                            
                                            <button 
                                                className='btn btn-sm btn-info' 
                                                style={{fontSize: '11px', padding: '2px 5px'}} 
                                                onClick={() => openReportModal(comp)} 
                                                title="Send Report"
                                            >
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </button>
                                            
                                            <button 
                                                className={`btn btn-sm ${comp.is_receipt == 1 ? 'btn-success' : 'btn-secondary'}`}
                                                style={{fontSize: '11px', padding: '2px 5px'}} 
                                                onClick={() => handleToggleReceipt(comp.id)}
                                                title={comp.is_receipt == 1 ? "Receipt: ON" : "Receipt: OFF"}
                                            >
                                                <FontAwesomeIcon icon={comp.is_receipt == 1 ? faToggleOn : faToggleOff} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    )
}
